export interface MenuItem {
  id: string;
  label: string;
  type?:
    | "muteSound"
    | "r2t"
    | "lang"
    | "contacts"
    | "sort-cards"
    | "auto-muck"
    | "jump-to-table"
    | "r2tgame"
    | "bbtournament"
    | "bbring"
    | "chips";
  valueRight?: string;
  children?: MenuItem[];
}

export const MAIN_MENU: MenuItem[] = [
  { id: "cashier", label: "Cashier" },
  { id: "tx", label: "Transaction History" },
  {
    id: "gifts",
    label: "Promotions",
    children: [
      { id: "bonuses", label: "Bonuses & Tickets" },
      { id: "rakeback", label: "True Rakeback" },
      { id: "referfriend", label: "Refer a friend" },
    ],
  },
  { id: "shop", label: "Shop" },

  {
    id: "settings",
    label: "Settings",
    children: [
      { id: "settings-mute", label: "Mute sounds", type: "muteSound" },
      { id: "settings-theme", label: "Theme settings" },
      { id: "settings-slider", label: "Slider shortcut buttons" },
      { id: "settings-r2t", label: "Run 2 Times (global)", type: "r2t" },
      { id: "settings-lang", label: "Language", type: "lang" },
    ],
  },

  {
    id: "profile",
    label: "Profile",
    children: [
      { id: "profile-hands", label: "Hand History" },
      { id: "profile-account", label: "Account Details" },
      { id: "profile-reset", label: "Reset Password" },
      { id: "profile-selfex", label: "Self Exclude" },
    ],
  },

  {
    id: "support",
    label: "Support",
    children: [
      { id: "support-report", label: "Report an issue" },
      { id: "contacts", label: "Contacts option", type: "contacts" },
    ],
  },

  {
    id: "legal",
    label: "Legal",
    children: [
      { id: "legal-privacy", label: "Privacy Policy" },
      { id: "legal-terms", label: "T&C" },
      { id: "legal-responsible", label: "Responsible" },
    ],
  },
  {
    id: "logout",
    label: "Logout",
  },
];

export const TABLE_SETTINGS: MenuItem[] = [
  {
    id: "table-settings",
    label: "Table settings",
    children: [
      {
        id: "cards-display",
        label: "Cards Display",
        children: [
          { id: "sort-cards", label: "Sort cards", type: "sort-cards" },
        ],
      },
      {
        id: "stack-display",
        label: "Stack Display",
        children: [
          {
            id: "stacks-bb-cash",
            label: "Stacks in BB (cash)",
            type: "bbring",
          },
          {
            id: "stacks-bb-tourn",
            label: "Stacks in BB (tournament)",
            type: "bbtournament",
          },
          { id: "chips", label: "Chips Display", type: "chips" },
        ],
      },

      {
        id: "gameplay",
        label: "Gameplay",
        children: [
          {
            id: "table-r2t",
            label: "Run it twice on this table",
            type: "r2tgame",
          },
          { id: "confirm-allin", label: "Confirmation before All-in" },
          { id: "auto-muck", label: "Auto muck", type: "auto-muck" },
          { id: "never-rabbit-hunt", label: "Never rabbit hunt" },
          { id: "post-bb-auto", label: "Post big blind automatically" },
        ],
      },
      { id: "auto-rebuy", label: "Auto Rebuy" },
      {
        id: "interface-experience",
        label: "Interface & Experience",
        children: [
          {
            id: "jump-to-table",
            label: "Jump to table",
            type: "jump-to-table",
          },
          { id: "swipe-table", label: "Swipe table" },
          { id: "show-empty-seat", label: "Show empty seat" },
        ],
      },
    ],
  },
];
